import { useHasAccess } from 'lib-shared-access-control';

import { flowsApi } from 'apis/flows';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

/**
 * A hook that checks whether the business hours feature in Analytics should be
 * enabled, based on feature flag state, user role and whether the organization
 * has at least one business hours schedule created.
 */
export const useHasAnalyticsBusinessHours = (): boolean => {
  const flags = useFeatureFlag(['analytics-business-hours']);

  const hasBusinessHoursAccess = useHasAccess('settings.business_hours', {
    fallbackRole: 'teamlead',
  });

  const hasFlagAndAccess =
    flags.analyticsBusinessHours && hasBusinessHoursAccess;

  const { data } = flowsApi.useReadFlowsSchedulesQuery(
    { limit: 1 },
    {
      skip: !hasFlagAndAccess,
    },
  );

  const hasBusinessHours =
    hasFlagAndAccess && !!data?.data.total_number_of_schedules;

  return hasBusinessHours;
};
